import { Field, useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../types/fields';
import { isEmpty } from '../../utils/getValidator';
import TextField from '../formik/TextField';

const validateSecondEmailField = (value: string, emailValue: string) => {
  const trimmedValue = typeof value === 'string' ? value.trim() : value;

  if (isEmpty(trimmedValue)) {
    return { key: 'required' };
  } else if (value !== emailValue) {
    return { key: 'secondEmailField' };
  } else {
    return undefined;
  }
};

const SecondEmailField = (props: FieldProps) => {
  const { formatMessage } = useIntl();
  const { values } = useFormikContext<any>();
  const { context, testIdPrefix } = props;

  return (
    <Field
      name={[context, 'secondEmailField'].filter(Boolean).join('.')}
      component={TextField}
      label={formatMessage({ id: 'generic.secondEmailField' })}
      maxLength={60}
      type="email"
      data-test-id={`${testIdPrefix}-secondEmailField`}
      validate={(value: string) => validateSecondEmailField(value, values.email)}
    />
  );
};

export default SecondEmailField;
